import React from 'react';

import styled from 'styled-components';
import { LoginVariant } from '../interfaces/login';

import Button from '@do/walrus/Button';

import { medium } from '@do/walrus/MediaQueries';
import vars from '@do/walrus/scss/core/_variables.scss';

interface VariantCopyProps {
  color?: string;
}

const WIDTH = '420px';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${vars.space_3};
  z-index: ${vars.z_index_base};
  text-align: center;
  width: ${WIDTH};

  ${medium} {
    margin-top: 10vh;
  }
`;

const Title = styled.h3<VariantCopyProps>`
  && {
    white-space: pre-line;
    padding: 0 ${vars.space_4};
    margin: ${vars.space_3} 0;
    color: ${({ color }) => (color ? color : 'initial')};

    ${medium} {
      padding: 0;
    }
  }
`;

const SubTitle = styled.h4<VariantCopyProps>`
  && {
    white-space: pre-line;
    padding: 0 ${vars.space_4};
    margin-top: 0;
    color: ${({ color }) => (color ? color : 'initial')};

    ${medium} {
      padding: 0;
    }
  }
`;

const SplashButton = styled(Button)`
  margin-top: ${vars.space_2};
`;

const ImgWrapper = styled.div`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

interface Props {
  variant: LoginVariant;
}

const LoginSplash: React.FC<Props> = ({ variant }) => {
  return (
    <Wrap>
      {variant.image && (
        <ImgWrapper
          data-testid="variantBackground"
          style={{
            backgroundImage: `url(${variant.image})`,
            height: `${variant.background.height}`,
            width: `${variant.background.width}`
          }}
        ></ImgWrapper>
      )}
      {variant.title && (
        <Title color={variant.textColor}>{variant.title}</Title>
      )}
      {variant.subtitle && (
        <SubTitle color={variant.textColor}>{variant.subtitle}</SubTitle>
      )}
      {variant.button && (
        <SplashButton
          variation={variant.button.variation || 'primary'}
          url={variant.button.url}
          fullWidth={variant.button.fullWidth}
          external
        >
          {variant.button.text}
        </SplashButton>
      )}
    </Wrap>
  );
};

export default LoginSplash;
